const translations = {
  "en": {
    "Contact Us": "Contact Us",
    "Manage Portfolios": "Manage Portfolios",
    "Start $1 Trial": "Start $1 Trial",
    "Upgrade": "Upgrade"
  },
  "zh-tw": {
    "Contact Us": "聯絡我們",
    "Manage Portfolios": "管理投資組合",
    "Start $1 Trial": "開始 1 美元試用",
    "Upgrade": "升級"
  }
};

export default translations;
